<template>
  <DsRadioGroup v-model="proxy" variant="button" :disabled="disabled">
    <DsRadioButton
      v-for="option in radioOptions"
      :key="option"
      :value="option"
      :label="option"
    />
  </DsRadioGroup>
</template>

<script lang="ts" setup>
import { DsRadioButton, DsRadioGroup } from '@demvsystems/design-components';
import { computed } from 'vue';

interface Props {
  modelValue: number;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  min: 1,
  max: 5,
  disabled: false,
});

const emit = defineEmits(['update:modelValue']);

const radioOptions = computed(() => {
  const options = [];
  for (let i = props.min; i <= props.max; i += 1) {
    options.push(i.toString());
  }

  return options;
});

const proxy = computed({
  get: () => props.modelValue.toString(),
  set: (val) => emit('update:modelValue', Number(val)),
});
</script>
